module.exports = __webpack_public_path__ + "static/media/purchase_list_cards.0b427af5.png";